module.exports = __webpack_public_path__ + "img/i2.f678bf80.jpg";